import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=76035561&"
import script from "./pagination-table.vue?vue&type=script&lang=js&"
export * from "./pagination-table.vue?vue&type=script&lang=js&"
import style0 from "./pagination-table.vue?vue&type=style&index=0&id=76035561&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports